import React from 'react';
import {
  Paper,
  CardContent,
  Box,
  Typography,
  Chip,
  Grid
} from '@mui/material';
import {
  AccessTime as AccessTimeIcon
} from '@mui/icons-material';
import { useWaitlist } from '../../hooks/useWaitlist';

interface WaitlistEnrollmentMessageProps {
  variant?: 'default' | 'compact';
  sx?: any;
}

const WaitlistEnrollmentMessage: React.FC<WaitlistEnrollmentMessageProps> = ({ 
  variant = 'default',
  sx = {}
}) => {
  const { config, isWaitlistMember } = useWaitlist();

  if (!isWaitlistMember) {
    return null;
  }

  const { WAITLIST_ENROLLMENT } = config.MESSAGES;

  if (variant === 'compact') {
    return (
      <Paper 
        elevation={0} 
        sx={{ 
          mb: 4, 
          background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
          color: 'white',
          borderRadius: 3,
          overflow: 'hidden',
          border: '1px solid rgba(255,255,255,0.2)',
          ...sx
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            <AccessTimeIcon sx={{ fontSize: 48, opacity: 0.9 }} />
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                {WAITLIST_ENROLLMENT.title}
              </Typography>
              <Typography variant="h6" sx={{ opacity: 0.9, mb: 2 }}>
                {WAITLIST_ENROLLMENT.subtitle}
              </Typography>
              <Typography variant="body1" sx={{ opacity: 0.8 }}>
                {WAITLIST_ENROLLMENT.description}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Paper>
    );
  }

  return (
    <Paper 
      elevation={0} 
      sx={{ 
        mb: 4, 
        background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
        color: 'white',
        borderRadius: 3,
        overflow: 'hidden',
        border: '1px solid rgba(255,255,255,0.2)',
        ...sx
      }}
    >
      <CardContent sx={{ p: 4 }}>
        <Grid container spacing={3} alignItems="center">
          <Grid size={{ xs: 12, md: 1 }} sx={{ textAlign: 'center' }}>
            <AccessTimeIcon sx={{ fontSize: 48, opacity: 0.9 }} />
          </Grid>
          <Grid size={{ xs: 12, md: 8 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
              {WAITLIST_ENROLLMENT.title}
            </Typography>
            <Typography variant="h6" sx={{ opacity: 0.9, mb: 2 }}>
              {WAITLIST_ENROLLMENT.subtitle}
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.8 }}>
              {WAITLIST_ENROLLMENT.description}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 3 }} sx={{ textAlign: { md: 'right' } }}>
            <Chip 
              label={WAITLIST_ENROLLMENT.chipLabel} 
              color="primary" 
              sx={{ 
                bgcolor: 'rgba(255,255,255,0.2)', 
                color: 'white',
                fontWeight: 600,
                fontSize: '1rem',
                py: 1
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Paper>
  );
};

export default WaitlistEnrollmentMessage; 